import { httpClient } from '../http/httpClient'

export interface UserDisableReason {
  reason: string
}

export async function userDisable(
  id: string,
  disableReason: UserDisableReason,
) {
  const { data } = await httpClient.patch(`/user/${id}/disable`, disableReason)

  return data
}
